<template>
  <div>
    <p class="mt-2" style="font-weight: 500; font-size: 14px">
      {{ description }}
    </p>
    <ScrollBar max-height="160px" class="mx-6">
      <div class="d-flex flex-column" style="background-color: #f6f7ff;">
        <span
          v-for="item in acl"
          :key="item.entityId"
          class="missingAcl pl-2"
        >
          {{ item.displayName }}
        </span>
      </div>
    </ScrollBar>
  </div>
</template>
<script>
import ScrollBar from '../scrollbar/ScrollBar';

export default {
  name: 'AclList',
  components: {
    ScrollBar,
  },
  props: {
    acl: {
      type: Array,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>
<style scoped>
.missingAcl {
  font-size: 13px;
}
</style>
